/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Schooladdress1Inputs */

const de__field_schooladdress1 = /** @type {(inputs: _Field_Schooladdress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schuladresse`)
};

/**

* @param {_Field_Schooladdress1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_schooladdress1 = /** @type {((inputs?: _Field_Schooladdress1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Schooladdress1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_schooladdress1(inputs)
});
export { _field_schooladdress1 as "_field_schoolAddress" }